import { LinkItemSchema } from '@/views/sports/components/CompetitionsMenu/styles/LinkItem.styles';

export const linkItemStyles: LinkItemSchema = {
  link: {
    display: 'flex',
    justifyContent: 'space-between',
    py: '2',
    pl: '3',
    pr: '2',
    borderBottomWidth: '1px',
    borderBottomColor: 'whiteAlpha.200',
    border: {
      _last: 'none',
    },
    _hover: {
      textDecoration: 'none',
      bg: 'blackAlpha.400',
    },
  },
  textCompetitionName: {
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxW: '140px',
    fontSize: 'xs',
    fontWeight: 'medium',
  },
  textMatchCount: {
    color: 'white',
    px: '1',
    textTransform: 'uppercase',
    fontSize: '3xs',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};
